import React, { useState } from 'react';
import { compressImage, getInitialsAvatar } from '../../utils/imageCompress';

export default function PhotoUpload({ contactId, currentPhoto, firstName, lastName, onPhotoUpdated }) {
  const [uploading, setUploading] = useState(false);
  const [preview, setPreview] = useState(currentPhoto || null);
  const [error, setError] = useState(null);

  const handleFileSelect = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    setError(null);
    setUploading(true);

    try {
      // Compress and get base64
      const compressedData = await compressImage(file);
      setPreview(compressedData);

      // Upload to backend
      if (contactId) {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/api/crm/contacts/${contactId}/upload-photo`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem('token')}`,
          },
          body: JSON.stringify({ imageData: compressedData }),
        });

        if (!response.ok) {
          throw new Error((await response.json()).error || 'Upload failed');
        }

        const result = await response.json();
        setPreview(result.photo_url);
        if (onPhotoUpdated) onPhotoUpdated(result.photo_url);
      }
    } catch (err) {
      setError(err.message);
      setPreview(currentPhoto);
    } finally {
      setUploading(false);
    }
  };

  const photoUrl = preview || currentPhoto || getInitialsAvatar(firstName, lastName);

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 12, alignItems: 'center' }}>
      <img
        src={photoUrl}
        alt={`${firstName} ${lastName}`}
        style={{
          width: 120,
          height: 120,
          borderRadius: '50%',
          objectFit: 'cover',
          border: '2px solid #22D3EE',
          backgroundColor: '#111827',
        }}
      />

      <label style={{
        padding: '8px 16px',
        background: '#22D3EE44',
        color: '#22D3EE',
        border: '1px solid #22D3EE66',
        borderRadius: 4,
        cursor: uploading ? 'not-allowed' : 'pointer',
        fontSize: 12,
        fontWeight: 500,
        opacity: uploading ? 0.6 : 1,
      }}>
        {uploading ? 'Uploading...' : 'Change Photo'}
        <input
          type="file"
          accept="image/*"
          onChange={handleFileSelect}
          disabled={uploading}
          style={{ display: 'none' }}
        />
      </label>

      {error && <div style={{ color: '#EF4444', fontSize: 12 }}>{error}</div>}
      <div style={{ color: '#6B7280', fontSize: 11 }}>JPG, PNG — auto-optimized to 200×200</div>
    </div>
  );
}
